/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSessionsResponseBody,
  ListSessionsResponseBody$inboundSchema,
} from "../components/listsessionsresponsebody.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListAgentSessionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAgentSessionsRequest = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  cursor?: string | undefined;
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListAgentSessionsResponse = {
  result: ListSessionsResponseBody;
};

/** @internal */
export type ListAgentSessionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentSessionsSecurity$outboundSchema: z.ZodMiniType<
  ListAgentSessionsSecurity$Outbound,
  ListAgentSessionsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAgentSessionsSecurityToJSON(
  listAgentSessionsSecurity: ListAgentSessionsSecurity,
): string {
  return JSON.stringify(
    ListAgentSessionsSecurity$outboundSchema.parse(listAgentSessionsSecurity),
  );
}

/** @internal */
export type ListAgentSessionsRequest$Outbound = {
  agent_id: string;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentSessionsRequest$outboundSchema: z.ZodMiniType<
  ListAgentSessionsRequest$Outbound,
  ListAgentSessionsRequest
> = z.pipe(
  z.object({
    agentId: z.string(),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAgentSessionsRequestToJSON(
  listAgentSessionsRequest: ListAgentSessionsRequest,
): string {
  return JSON.stringify(
    ListAgentSessionsRequest$outboundSchema.parse(listAgentSessionsRequest),
  );
}

/** @internal */
export const ListAgentSessionsResponse$inboundSchema: z.ZodMiniType<
  ListAgentSessionsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSessionsResponseBody$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listAgentSessionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentSessionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentSessionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentSessionsResponse' from JSON`,
  );
}
